import React from 'react'
import CustomLink from '../components/CustomLink'
import ForgotPasswordForm from '../forms/ForgotPasswordForm'
import AuthLayout from './AuthLayout'
import globals from '../globals'

class ForgotPassword extends React.Component {
    render () {
        return (
            <AuthLayout
                title='Forgot your password'
                description='If you have forgotten your password, enter your details below and we will email you a link to reset your password and get you back up and running.'
            >
                <ForgotPasswordForm
                    handleSuccess={() => globals.pushEvent('ResetPasswordRequest')}
                />
                <div className='row'>
                    <div className='col-12 text-center mt-5'>
                        <small>Return to <CustomLink to='/login' className='return-to'>My Exetel</CustomLink></small>
                    </div>
                </div>
            </AuthLayout>
        )
    }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./resources/js/auth/ForgotPassword.js